"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iReliablePartnerPdfStatusFailedEvent = exports.iReliablePartnerPdfStatusSuccessEvent = exports.GENERATE_REPORT_STATUS_FAILED = exports.GENERATE_REPORT_STATUS_SUCCESS = void 0;
const t = require("io-ts");
exports.GENERATE_REPORT_STATUS_SUCCESS = 'GENERATE_REPORT_STATUS_SUCCESS';
exports.GENERATE_REPORT_STATUS_FAILED = 'GENERATE_REPORT_STATUS_FAILED';
const iSuccessMessage = t.interface({
    participantUuid: t.string
});
const iFailedMessage = t.interface({
    error: t.string,
    participantUuid: t.string
});
exports.iReliablePartnerPdfStatusSuccessEvent = t.interface({
    event: t.literal(exports.GENERATE_REPORT_STATUS_SUCCESS),
    message: iSuccessMessage
});
exports.iReliablePartnerPdfStatusFailedEvent = t.interface({
    event: t.literal(exports.GENERATE_REPORT_STATUS_FAILED),
    message: iFailedMessage
});
//# sourceMappingURL=reliablePartnerPdfStatusEvent.js.map